import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, CardBody } from "reactstrap";
import AuditSelectSection from "./AuditSelectSection";
import RecommendationSection from "./RecommendationSection";
import UrlSelectSection from "./UrlSelectSection";

export default function WritingAssistantWizardCard({
	audits,
	loadingAudits,
	recommendations,
	loadingRecs,
	auditId,
	selectedRecommendationId,
	selectedPageUrl,
	selectedRec,
	selectedPage,
	activeJobId,
	canGenerate,
	onAuditSelect,
	onRecommendationSelect,
	onPageSelect,
	onGeneratePreview,
}) {
	const navigate = useNavigate();

	const showViewPreview = activeJobId != null;
	const ctaLabel = showViewPreview ? "View Action Items" : "Generate Fix";
	const hasSelection = selectedRecommendationId != null && selectedPageUrl;
	const ctaDisabled =
		!hasSelection ||
		(showViewPreview ? false : !canGenerate || selectedRec?.processed === true);

	const handleCta = () => {
		if (showViewPreview && activeJobId != null) {
			navigate(
				`/aivisibility/writing-assistance/view?jobId=${encodeURIComponent(activeJobId)}`
			);
			return;
		}
		onGeneratePreview();
	};

	return (
		<Card className="shadow-sm writing-assistance__wizard-card">
			<CardBody className="p-4">
				<h4 className="writing-assistance__wizard-title mb-2">
					AI Visibility Writing Assistant
				</h4>
				<p className="writing-assistance__wizard-subtitle text-muted mb-4">
					Choose a completed AEO audit, pick a Content Team recommendation with affected
					pages, then select the page URL to preview improvements.
				</p>

				<AuditSelectSection
					audits={audits}
					loading={loadingAudits}
					auditId={auditId}
					onSelect={onAuditSelect}
				/>

				{auditId != null && (
					<RecommendationSection
						auditId={auditId}
						recommendations={recommendations}
						loading={loadingRecs}
						selectedRecommendationId={selectedRecommendationId}
						onSelect={onRecommendationSelect}
					/>
				)}

				{selectedRec && (
					<UrlSelectSection
						pages={selectedRec.affected_pages}
						selectedPageUrl={selectedPageUrl}
						onSelect={onPageSelect}
						recommendationId={selectedRecommendationId}
					/>
				)}

				{auditId != null && (
					<Button
						color="primary"
						className="writing-assistance__cta mt-4"
						disabled={ctaDisabled}
						onClick={handleCta}
					>
						{ctaLabel}
					</Button>
				)}

				{showViewPreview && hasSelection && activeJobId && selectedPage && (
					<p className="text-muted small mb-0 mt-2">
						Preview ready for {selectedPage.url}
					</p>
				)}

				{showViewPreview && hasSelection && !activeJobId && (
					<p className="text-muted small mb-0 mt-2">
						No preview available for this URL.
					</p>
				)}
			</CardBody>
		</Card>
	);
}

